<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmImports"
            :title="$lang.Imports.TitleForms"
            :showHelp="true"
            :showClearButton="true"
            :showSaveButton="true"
            :disabledKeyUpEnter="true"
            v-on:Clear="clearFields"
            v-on:Save="validateData">

      <div class="form-group row">
        <div class="col-md-3">
          <label for="cbxInsuranceID"><small class="text-danger">*</small> {{$lang.Sinister.Search.Insurer}}:</label>
          <div class="input-group">
            <b-form-select
                          id="cbxInsuranceID"
                          name="cbxInsuranceID"
                          v-model="form.insuranceID.value"
                          :options="getAllInsurer"
                          :state="form.insuranceID.state"
                          @change="onChangeInsurance">
                <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="cbxBusinessType">{{$lang.Sinister.Details.BusinessType}}:</label>
          <div class="input-group">
            <b-form-select v-model="form.businessTypeID.value"
                          :options="form.businessTypeID.options"
                          :state="form.businessTypeID.state"
                          class="mb-3"
                          name="cbxBusinessType">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
           <label for="cbxSchedulingType"><small v-show="form.schedulingTypeID.required" class="text-danger">*</small> {{$lang.Imports.SchedulintType}}:</label>
          <div class="input-group">
            <b-form-select name="cbxSchedulingType"
                          v-model="form.schedulingTypeID.value"
                          :options="form.schedulingTypeID.options"
                          :state="form.schedulingTypeID.state"
                          class="mb-3">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-3">
          <label for="cbxSinisterResponsible"><small class="text-danger">*</small> {{$lang.Sinister.Details.Responsible}}:</label>
          <div class="input-group">
            <b-form-select name="cbxSinisterResponsible"
                          v-model="form.responsibleID.value"
                          :options="getAllAnalyst"
                          :state="form.responsibleID.state"
                          class="mb-3">
              <template slot="first">
                <option :value="null" disabled>{{$lang.Common.PlaceholderSelect}}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="txtDescription"><small class="text-danger">*</small>
            {{$lang.Imports.InsertDataRegulationEmail}}:
          </label>
          <label>
            <small class="required-field-bottom" style="color: #909090;">
              {{$lang.Imports.Alerts.RequiredNewline}}
            </small>
          </label>
          <div class="input-group">
              <b-form-textarea
                  name="txtDescription"
                  v-model.trim="form.description.value"
                  :placeholder="$lang.Imports.PlaceholderDataRegulationEmail"
                  :cols="form.description.cols"
                  :rows="form.description.rows"
                  :size="form.description.maxlength"
                  :noResize="form.description.noResize"
                  ></b-form-textarea>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 text-center">
          <button id="btnImportExcel" type="button" class="btn btn-third btn-sm" @click="onPickFile()" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonImportExcel">
            <i class="fa fa-cloud-upload"></i> {{$lang.Common.Buttons.ImportExcel}}
          </button>&nbsp;
          <input
            type="file"
            style="display: none"
            ref="fileInput"
            accept="*.xls,*.xlsx"
            v-on:change="onFilePicked"/>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label for="lblImports">
             Importados hoje: {{this.form.save.value}}.
          </label>
        </div>
      </div>
    </Forms>

    <div ref="frmListImports">
      <Tables ref="tableGrid"
        v-if="filteredData !== null"
        :columns="[
                    $lang.Imports.DataTable.Insurer,
                    $lang.Imports.DataTable.RegulationType,
                    $lang.Imports.DataTable.Sinister,
                    $lang.Imports.DataTable.Date,
                    $lang.Imports.DataTable.Advise,
                    $lang.Imports.DataTable.Plate,
                    $lang.Imports.DataTable.Model,
                    $lang.Imports.DataTable.MechanicalWorkshop,
                    $lang.Imports.DataTable.Status,
                    $lang.Common.DataTable.Actions]"
        :showSearch="true"
        :showPrint="true"
        :showDownload="false"
        :showFullscreen="true"
        v-on:Load="onLoad">
        <tr v-for="(obj, key, index) in filteredData" v-bind:key="index">
          <TableColumn :IsText="true"     :status="obj.status" :value="getInsuranceDescription(obj.insurance)" v-on:Edit="onEdit(obj)"/>
          <td class="text-center">
            <a href="javascript:void(0)"  v-bind:class="{'text-danger':(obj.status == false)}">
              {{ (obj.regulationType !== null) ? obj.regulationType.name: 'N/D' }}
            </a>
            <b-form-select v-show="((obj.status == false || obj.importMessage !== 'IMPORTADO') && obj.regulationTypes !== null)"
              ref="cbxRegulationType"
              style="width: 100%"
              name="cbxRegulationType"
              class="form-control"
              v-model="obj.regulationTypeID"
              >
              <option v-for="(regulationType, index) in obj.regulationTypes" :key="index" :value="regulationType.id" >{{regulationType.name}}</option>
            </b-form-select>
          </td>
          <TableColumn :IsText="true"     :status="obj.status" :value="obj.sinisterFull"  v-on:Edit="onEdit(obj)"/>
          <TableColumn :IsDateOnly="true" :status="obj.status" :value="obj.sinisterDate"  v-on:Edit="onEdit(obj)"/>
          <TableColumn :IsText="true"     :status="obj.status" :value="obj.claimNumber"   v-on:Edit="onEdit(obj)"/>
          <TableColumn :IsText="true"     :status="obj.status" :value="obj.plate"         v-on:Edit="onEdit(obj)"/>
          <td class="text-center">
            <a href="javascript:void(0)"  v-bind:class="{'text-danger':(obj.status == false)}" v-on:click="onEdit(obj)">
              {{ (obj.autoModel !== null) ? obj.autoModel.description: 'N/D' }}
            </a>
            <b-form-select v-show="((obj.status == false || obj.importMessage !== 'IMPORTADO') && obj.autoModels !== null)"
              ref="cbxAutoModel"
              style="width: 100%"
              name="cbxAutoModel"
              class="form-control"
              v-model="obj.autoModelID"
              :state="form.insuranceID.state" >
              <option v-for="(automodel, index) in obj.autoModels" :key="index" :value="automodel.id" >{{automodel.name}}</option>
            </b-form-select>
          </td>
          <TableColumn :IsText="true"     :status="obj.status" :value="(obj.mechanicalWorkshop !== null) ? obj.mechanicalWorkshop.name : ''" v-on:Edit="onEdit(obj)"/>
          <td class="text-left">
            <a href="javascript:void(0)"  v-bind:class="{'text-danger':(!obj.status)}" v-on:click="onEdit(obj)">
              <span v-html="(obj.importMessage !== null) ? '<ul>' + obj.importMessage + '</ul>' : 'N/D'"/>
            </a>
          </td>
          <td class="text-center">
            <div>
              <b-dropdown  variant="link" size="sm" no-caret v-if="obj.importMessage !== 'IMPORTADO'">
                <template slot="button-content">
                  <i class="fa fa-trash text-secundary icone-grid"></i><span class="sr-only">{{$lang.Common.Buttons.Delete}}</span>
                </template>
                <b-dropdown-header><strong>{{$lang.Common.ConfirmDelete}}</strong></b-dropdown-header>
                <b-dropdown-item href="javascript:void(0);" v-on:click="onDelete(obj)">{{$lang.Common.Yes}}</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0);">{{$lang.Common.No}}</b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </Tables>
    </div>

    <div class="form-group row pt-2">
      <div class="col-md-12 text-center">
        <button type="button" class="btn btn-third btn-sm" @click="importData()" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonImport">
          <i class="fa fa-cloud-upload"></i> {{$lang.Common.Buttons.Import}}
        </button>&nbsp;
      </div>
    </div>
  </div>
</template>
<script>
import ImportRegulationAuto from './importregulationauto.js'

export default ImportRegulationAuto
</script>



// WEBPACK FOOTER //
// src/views/private/regulation/imports/importregulationauto.vue